import { render, staticRenderFns } from "./RelatedOrder.vue?vue&type=template&id=2cf0aca9&scoped=true&"
import script from "./RelatedOrder.vue?vue&type=script&lang=js&"
export * from "./RelatedOrder.vue?vue&type=script&lang=js&"
import style0 from "./RelatedOrder.vue?vue&type=style&index=0&id=2cf0aca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0aca9",
  null
  
)

export default component.exports